import { routes } from "@/apps/whiteLabelWebsite/whiteLabel/routing/routes";

const router = [
  {
    path: routes.cookiesPolicy.path,
    name: routes.cookiesPolicy.name,
    component: () =>
      import(
        /* webpackChunkName: "cookies-policy" */ "@/apps/whiteLabelWebsite/whiteLabel/view/pages/CookiePolicy/CookiesPolicy.vue"
      ),
    meta: {
      shouldDisplayClientWebsiteLink: true,
    },
  },
  {
    path: routes.cookiesPolicyDocument.path,
    name: routes.cookiesPolicyDocument.name,
    component: () =>
      import(
        /* webpackChunkName: "cookies-policy" */ "@/apps/whiteLabelWebsite/whiteLabel/view/pages/CookiePolicy/CookiesPolicyDocument.vue"
      ),
  },
  {
    path: routes.accessibilityStatement.path,
    name: routes.accessibilityStatement.name,
    component: () =>
      import(
        /* webpackChunkName: "accessibility-statement" */ "@/apps/whiteLabelWebsite/whiteLabel/view/pages/AccessibilityStatementDocument.vue"
      ),
  },
];

export default router;
